<template>
	<div class="moonSampleHome">
		<div class="moonContent">
			<div class="firstDivClass">
				<img class="imgClass" src="./../../assets/moonsamples/index_01.png" />
				<div class="contentValueClass">
					<div class="spanTitleClass">
						<div>
							<span class="nameClass">{{ $t('MoonSample.MoonSampleInformationAnnouncement') }}</span>
						</div>
						<span class="moreClass" @click="moreInforFunc()">{{ $t('MoonSample.More') }}</span>
					</div>
					<div class="contentDivClass">
						<div style="padding-bottom: 20px" v-for="(item, indexNotice) in noticeArrData" :key="indexNotice">
							<div class="titleSpanClass" @click="moreInforFunc(item)">
								<span class="nameClass" :title="item.title">{{ item.title }}</span>
								<span class="timeClass">{{ item.createTime }}</span>
							</div>
							<span class="valueSpanClass" v-html="item.content"></span>
						</div>
					</div>
				</div>
			</div>
			<div class="secondDivClass">
				<div class="moreDivClass">
					<span class="titleClass">{{ $t('MoonSample.LatestNews') }}</span>
					<span class="moreClass" @click="moreNewFunc()">{{ $t('MoonSample.More') }}</span>
				</div>
				<div class="secondContentClass">
					<img src="./../../assets/moonsamples/data-img.png" />
					<div class="titleContentClass" id="data-list">
						<div class="titleNameClass" v-for="(item, index) in newArrData" :key="index" @click="moreNewFunc(item)">
							<span class="nameClass" :title="item.title">{{ item.title }}</span>
							<span>{{ item.createTime }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'moonSampleHome',
	data() {
		return {
			totalNewData: {},
			noticeArrData: [],
			newArrData: [],
			contentArr: []
		}
	},
	mounted() {
		this.initDataFunc()
	},
	methods: {
		moreInforFunc(item) {
			this.$router.replace({ path: '/moonSampleHomeInfo', query: { type: 'notice', param: item } })
		},
		moreNewFunc(item) {
			this.$router.replace({ path: '/moonSampleHomeInfo', query: { type: 'new', param: item } })
		},
		async initDataFunc() {
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleNewList)
			if (res && res.code == 200) {
				this.noticeArrData = []
				this.newArrData = []
				this.totalNewData = res.rows
				// 新闻资讯类型;1:数据发布,2:动态新闻,3:最新成果,4:通知公告,5:其他
				res.rows.forEach((element) => {
					if (element.newsType == 1) {
						this.noticeArrData.push(element)
					} else if (element.newsType == 2) {
						this.newArrData.push(element)
					}
				})
			}
		},
		initFunc() {
			const items = document.querySelectorAll('#data-list .titleNameClass')
			let currentIndex = 0

			function rotateItems() {
				items[currentIndex].style.display = 'none' // 隐藏当前项
				currentIndex = (currentIndex + 1) % items.length // 计算下一个索引
				items[currentIndex].style.display = 'block' // 显示下一个项
			}
			setInterval(rotateItems, 2000)
			// setInterval(() => {
			//       let newArray = [...this.contentArr.slice(1), this.contentArr[0]]; // 除了第一个元素外，其他元素后跟第一个元素
			//         this.contentArr = newArray; // 更新原数组（可选）
			// }, 2000);
		}
	}
}
</script>

<style lang="scss" scoped>
.moonSampleHome {
	// background-image: url("~@/assets/imgs/newHome/bg.png");
	background-image: url('~@/assets/moonsamples/moonbj.png');
	background-size: 100% 100%; /* 宽度和高度都设置为100% */
	/* 替换为你的背景图URL */
	// background-size: cover;
	/* 背景图按容器比例缩放，保证图片覆盖整个容器 */
	background-repeat: no-repeat;
	/* 背景图不重复 */
	// background-position: center;
	width: 100%;
	// height: 818px;
	display: flex;
	justify-content: center;
	.moonContent {
		width: 70%;
		margin-bottom: 20px;
		margin: 0 auto;
	}
	.firstDivClass {
		display: flex;
		justify-content: center;
		margin-top: 20px;
		margin-left: -10px;
		.imgClass {
			width: 50%;
			height: 440px;
		}
		.contentValueClass {
			// background: rgba(21, 65, 140, 0.08);
			background: #ffffff;
			width: 50%;
			height: 440px;
			padding: 20px;
			.spanTitleClass {
				display: flex;
				justify-content: space-between;
				padding-bottom: 10px;
				display: flex;
				// margin: 20px;
				border-bottom: 1px solid rgba(21, 65, 140, 0.2);
				.titleImgClass {
					width: 24px;
					height: 24px;
				}
				.nameClass {
					padding-left: 10px;
					font-family: MicrosoftYaHeiUISemibold;
					font-size: 18px;
					color: #ffffff;
					letter-spacing: 0;
					font-weight: 600;
					width: 249px;
					height: 32px;
					display: block;

					background-image: url('./../../assets/moonsamples/spanBJ.png');
					/* 替换为你的背景图URL */
					background-size: cover;
					background-size: 100% 100%;
					/* 背景图按容器比例缩放，保证图片覆盖整个容器 */
					background-repeat: no-repeat;
					/* 背景图不重复 */
					background-position: center;
				}
				.moreClass {
					font-family: MicrosoftYaHeiUI;
					font-size: 18px;
					color: #15418c;
					letter-spacing: 0;
					font-weight: 400;
					cursor: pointer;
				}
			}
			.contentDivClass {
				padding-top: 20px;
				overflow: auto;
				padding-right: 10px;
				height: 360px;
				.titleSpanClass {
					display: flex;
					height: 34px;
					align-items: baseline;
					justify-content: space-between;
					cursor: pointer;
					.timeClass {
						font-family: MicrosoftYaHeiUI;
						font-size: 16px;
						color: #15418c;
						letter-spacing: 0;
						font-weight: 400;
					}
					.nameClass {
						font-family: MicrosoftYaHeiUISemibold;
						font-size: 22px;
						color: #15418c;
						letter-spacing: 0;
						line-height: 28px;
						font-weight: 600;
						width: 70%;
						white-space: nowrap; /* 防止文本换行 */
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}
				.valueSpanClass {
					font-family: MicrosoftYaHeiUI;

					font-size: 18px;
					color: #333333;
					line-height: 32px;
					text-align: left;
					font-style: normal;
				}
			}
		}
		img {
			height: 320px;
		}
	}
	.secondDivClass {
		display: flex;
		justify-content: center;
		flex-direction: column;
		margin-bottom: 20px;
		.moreDivClass {
			height: 70px;
			align-items: center;
			display: flex;
			justify-content: space-between;
			.titleClass {
				font-family: MicrosoftYaHeiUISemibold;
				font-size: 28px;
				color: #000000;
				letter-spacing: 0;
				font-weight: 600;
			}
			.moreClass {
				font-family: MicrosoftYaHeiUI;
				font-size: 18px;
				color: #15418c;
				letter-spacing: 0;
				font-weight: 400;
				cursor: pointer;
			}
		}

		.secondContentClass {
			display: flex;
			justify-content: center;
			img {
				width: 480px;
				height: 300px;
			}
			.titleContentClass {
				display: flex;
				flex-direction: column;
				// width: 1350px;
				width: 1300px;
				overflow: auto;
				height: 300px;
				margin-left: 10px;
				.titleNameClass {
					display: flex;
					padding: 16px 0px;
					// height: 54px;
					font-family: MicrosoftYaHeiUI;
					font-size: 18px;
					color: #333333;
					letter-spacing: 0;
					font-weight: 400;
					justify-content: space-between;
					cursor: pointer;
					border-bottom: 1px solid #eee7e7;
					.nameClass {
						width: 70%;
						white-space: nowrap; /* 防止文本换行 */
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}
				.titleNameClass:hover {
					background: rgba(21, 65, 140, 0.08);
					font-family: MicrosoftYaHeiUISemibold;
					font-size: 18px;
					color: #15418c;
					letter-spacing: 0;
					font-weight: 600;
					padding: 16px 0px;
				}
			}
		}
	}
}
</style>
